"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.summaryDwsAuto = summaryDwsAuto;
exports.summaryUndoDwsAuto = summaryUndoDwsAuto;
exports.summaryDwsRoleSectionBulkDelete = summaryDwsRoleSectionBulkDelete;
async function summaryDwsAuto(userId, activeBranchId, payload) {
    const requestURL = `/dashboard/${userId}/summary/dws_auto?c=${activeBranchId}`;
    try {
        const response = await fetch(requestURL, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
async function summaryUndoDwsAuto(userId, activeBranchId, payload) {
    const requestURL = `/dashboard/${userId}/summary/dws_auto/undo?c=${activeBranchId}`;
    try {
        const response = await fetch(requestURL, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
async function summaryDwsRoleSectionBulkDelete(userId, params) {
    const searchParam = new URLSearchParams();
    if (params.branchId) {
        searchParam.set("c", params.branchId.toString());
    }
    if (params.date) {
        searchParam.set("date", params.date);
    }
    if (params.roles) {
        searchParam.set("roles", params.roles);
    }
    if (params.tags) {
        searchParam.set("tags", params.tags);
    }
    searchParam.set("autoOnly", params.autoOnly.toString());
    searchParam.set("list", "day");
    const url = `/dashboard/${userId}/summary/role_section/bulk_delete?${searchParam}`;
    try {
        const response = await fetch(url, {
            method: 'DELETE',
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
